import { render, staticRenderFns } from "./FeedbackApproval.vue?vue&type=template&id=5e401630"
import script from "./FeedbackApproval.vue?vue&type=script&lang=ts"
export * from "./FeedbackApproval.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackApproval.vue?vue&type=style&index=0&id=5e401630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports